import React from 'react';
import dynamic from 'next/dynamic';
import classnames from 'classnames/bind';
import styles from './tutorial.module.scss';
const ReactPlayer = dynamic(() => import('react-player') as any, { ssr: false }) as any;

const cx = classnames.bind(styles);

const Main = () => {
  return (
    <div className={cx('mainArea')}>
      <div className={cx('videoWrap')}>
        <ReactPlayer
          url={`/video/acc/tutorial/videoMain.mp4`}
          playing={true}
          muted={true}
          loop={true}
          width={'100%'}
          height={'100%'}
        />
      </div>
      <div className={cx('mainInner')}>
        <span className={cx('text')}>역검 수련하기</span>
        <strong className={cx('desc')}>
          <span className={cx('textEmphasis')}>역검</span> 준비는
          <br />
          잡다에서 <span className={cx('textEmphasis')}>역검</span> 수련으로 끝!
        </strong>
        <span className={cx('subText')}>feat. 공식 개발사</span>
      </div>
      <span className={cx('scrollDown')}>SCROLL DOWN</span>
    </div>
  );
};

export default Main;
